exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderer-container {\r\n    font-size: 13px;\r\n}\r\n\r\n/* styling for hyperlink column  starts*/\r\n.renderer-default {\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n    overflow: hidden;\r\n    -webkit-user-select: text;\r\n       -moz-user-select: text;\r\n        -ms-user-select: text;\r\n            user-select: text;\r\n}\r\n.hyperlink-content {\r\n    cursor: pointer;\r\n    color: #0073AB;\r\n}\r\na:hover {\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n/* styling for hyperlink column  ends*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/assign-lane-popup/assign-lane-cell-renderer/assign-lane-cell-renderer.component.css
// module id = ../../../../../src/app/shared/lookup/assign-lane-popup/assign-lane-cell-renderer/assign-lane-cell-renderer.component.css
// module chunks = main